import { useTranslation } from "react-i18next";
import IDevice from "../../models/devices/IDevice";
import { useEffect, useState } from "react";
import ILAPSDetails from "../../models/devices/ILAPSDetails";
import Status from "../../enums/Status";
import { Col, Row } from "react-grid-system";
import deviceService from "../../services/deviceService";
import { LAPSError as Error } from "./Error";
import Placeholder from "./Placeholder";
import { formatDate, getUnixTimestamp } from "../../utilities/dates";
import { EyeFilled, EyeOffFilled } from "@fluentui/react-icons";
import { Button, Tooltip } from "@fluentui/react-components";
import useStyleUtils from "../../utilities/styles";
import styles from "./LAPS.module.scss";

const LAPSDetails = ({ laps }: { laps: ILAPSDetails[] }) => {
    const { t } = useTranslation();

    const style = useStyleUtils();

    const [show, setShow] = useState(false);

    const latestLaps = laps.sort((a, b) => getUnixTimestamp(b.lastRotation) - getUnixTimestamp(a.lastRotation))[0];

    const lastRotation = formatDate(latestLaps.lastRotation, "DD/MM/YYYY HH:mm"),
        nextRotation = formatDate(latestLaps.nextRotation, "DD/MM/YYYY HH:mm");

    const password = show
        ? `<span class="${styles.password}">${atob(latestLaps.password)}</span>`
        : "••••••";

    const visibilityTooltipText = show
        ? t("passwords.visibility.toggleHide")
        : t("passwords.visibility.toggleShow");

    const icon = show 
        ? <EyeOffFilled onClick={() => setShow(false)} />
        : <EyeFilled onClick={() => setShow(true)} />;

    return (
        <Row>
            <Col xs={12}>
                <ul>
                    <li dangerouslySetInnerHTML={{ __html: t("devices.fields.laps.lastRotated", { date: lastRotation }) }} />
                    <li dangerouslySetInnerHTML={{ __html: t("devices.fields.laps.nextRotation", { date: nextRotation }) }} />
                    <li dangerouslySetInnerHTML={{ __html: t("devices.fields.laps.username", { username: latestLaps.username }) }} />
                    <li>
                        <span dangerouslySetInnerHTML={{ __html: t("devices.fields.laps.password", { password }) }} />
                        <Tooltip content={visibilityTooltipText} relationship='label'>
                            <Button icon={icon} size="small" className={style.ml2} />
                        </Tooltip>
                    </li>
                </ul>
            </Col>
        </Row>
    );
};

export default function LAPS(props: { device: IDevice }) {
    const { device } = props;
    const { t } = useTranslation();

    const [LAPS, setLAPS] = useState<ILAPSDetails[]>([]);
    const [status, setStatus] = useState<Status>(Status.LOADING);

    const load = () => {
        setStatus(Status.LOADING);

        deviceService.getLAPS(device.id)
            .then((laps) => {
                setLAPS(laps);
                setStatus(Status.LOAD_SUCCESS);
            })
            .catch(() => setStatus(Status.LOAD_ERROR));
    };

    useEffect(load, [device.id]);

    return (
        <Row>
            <Col xs={12}>
                <h3>{t("devices.titles.laps")}</h3>
               {
                    status === Status.LOADING && <Placeholder />
                }
                {
                    status === Status.LOAD_ERROR && <Error />
                }
                {
                    status === Status.LOAD_SUCCESS &&
                    <LAPSDetails laps={LAPS} />
                }
            </Col>
        </Row>
    );
}